import './_hotspots.scss';
import Hotspot from "./hotspot/hotspot";

export default function Hotspots() {
    return (<div className="hotspots">
        <Hotspot
            id='garage_btn'
            title='View interactive floor plan'
            content='Open link to interactive floor plan in new window.'
            url='https://google.com'
        />
        <Hotspot
            id='indoor_btn'
            title='View indoor virtual tour'
            content='Open link to indoor virtual tour in new window.'
            url='https://google.com'
        />
    </div>);
}
